import React from 'react';
import { Button, Text, Flex, useColorModeValue } from '@chakra-ui/react';

const BookMeeting = () => {
  const buttonBg = useColorModeValue('brand.500', 'gray.800');
  const buttonColor = useColorModeValue('white', 'white');

  const handleBookMeeting = async (event) => {
    event.preventDefault();
    window.open('https://calendly.com/ressi-54/30min', '_blank');
  };
  return (
    <Flex
      height="100vh"
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Text fontSize="xl" mb={4}>
        Book a meeting with us to start sending emails
      </Text>
      <Button
        fontSize="sm"
        variant="brand"
        fontWeight="500"
        w="20%"
        h="50"
        mb="24px"
        onClick={handleBookMeeting}
        bg={buttonBg}
        color={buttonColor}
      >
        Book Meeting
      </Button>
    </Flex>
  );
};

export default BookMeeting;
